export const getEnumValues = <T extends string | number = number>(enumType: Enum): T[] => {
    const values = Object.values(enumType);
    const isAllString = values.every((value) => typeof value === "string");
    if (isAllString) {
        return Object.values(enumType);
    }
    const enumValuesCount = Object.values(enumType).length / 2;
    return Object.values(enumType).slice(enumValuesCount);
};

interface Enum {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}
